export const decor = {
  switch: () => import(/* webpackChunkName: 'logic' */ './switch'),
}

export const install = {
  install: Vue => {
    Vue.component('logic-switch', decor.switch)
  },
}
